import { ReactElement } from "react";

import OrderConfirmationSetItem from "./OrderConfirmationSetItem";

interface IProps {
	setItems: any[]; // Using any since the API type is not well defined
}

const OrderConfirmationSetItems = ({ setItems }: IProps): ReactElement => {
	return (
		<ul className="CartItemSet">
			{setItems.map((setItem, setIndex) => (
				<OrderConfirmationSetItem
					key={`${setItem.food_supplier_menu_item_id || ""}-${setItem.title_en || setItem.title || ""}-${setIndex}`}
					setItem={setItem}
				/>
			))}
		</ul>
	);
};

export default OrderConfirmationSetItems;
